import React from 'react';
import './App.css';
import ChatComponent from './ChatComponent';
import {ThemeProvider} from 'styled-components';
import {getQueryParam} from './utils/getQueryParam';

const themes = {
  dark: {
    acBtnBackgroundColor: 'rgba(38, 38, 38, 1)',
    acBtnTextColor: 'rgba(230, 224, 233, 1)',
    acBtnGradientHover: 'linear-gradient(0deg, #333333, #333333)',
    acBtnGradientActive: 'linear-gradient(0deg, #111111,  #111111)',
    scrollBackgroundColor: 'rgba(28, 28, 28, 1)',
    scrollThumbColor: 'rgba(151, 151, 151, 1)',
    suggestedBtnBackgroundColorHover: 'rgba(51, 51, 51, 1)',
    suggestedBtnBorderHover: 'rgba(62, 63, 67, 1)',
    suggestedBtnTextHover: 'rgba(174, 176, 184, 1)',
    suggestedBtnBackgroundColorActive: 'rgba(17, 17, 17, 1)',
    suggestedBtnBorderActive: 'rgba(62, 63, 67, 1)',
    suggestedBtnTextActive: 'rgba(174, 176, 184, 1)',
    gradientColor: 'linear-gradient(to right,  #2ED5F0 0%, #5377ED 100%)'
  },
  light: {
    acBtnBackgroundColor: 'rgba(38, 38, 38, 1)',
    acBtnTextColor: 'rgba(230, 224, 233, 1)',
    acBtnGradientHover: 'linear-gradient(0deg, #333333, #333333)',
    acBtnGradientActive: 'linear-gradient(0deg, #111111,  #111111)',
    scrollBackgroundColor: 'rgba(28, 28, 28, 1)',
    scrollThumbColor: 'rgba(151, 151, 151, 1)',
    suggestedBtnBackgroundColorHover: 'rgba(51, 51, 51, 1)',
    suggestedBtnBorderHover: 'rgba(62, 63, 67, 1)',
    suggestedBtnTextHover: 'rgba(174, 176, 184, 1)',
    suggestedBtnBackgroundColorActive: 'rgba(51, 51, 51, 1)',
    suggestedBtnBorderActive: 'rgba(62, 63, 67, 1)',
    suggestedBtnTextActive: 'rgba(174, 176, 184, 1)',
    gradientColor: 'linear-gradient(to right,  #30F0EC 0%, #2FB7F0 100%)'
  }
}

function app() : JSX.Element {
  const themeParam = getQueryParam('theme');
  const theme = themeParam === 'light' ? themes.light : themes.dark;

  return (
      <ThemeProvider theme={theme}>
        <ChatComponent />
      </ThemeProvider>
  );
}

export default app;
